type CheckFn = (url: string) => boolean;

type MockFn = ({
  body,
  pathParams,
  queryParams,
}: {
  pathParams?: Record<string, string>;
  queryParams?: Record<string, string>;
  body: object;
}) => object | undefined;

type MockHook = { checkFn: CheckFn; mockFn: MockFn };

// Hook Definitions:
// Each hook describes the matching criteria (endpoint)
// and the mock fn to resolve data for that request
// Configure the mock hooks here according to the HTTP verb
const mockHooks: { [method: string]: MockHook[] } = {
  get: [],
  patch: [],
  put: [],
  post: [],
  delete: [],
  option: [],
};

type MockedResponseParams = {
  url: string;
  method: string;
  body: object;
  pathParams?: Record<string, string>;
  queryParams?: Record<string, string>;
};

/**
 * Used to mock responses from the toolkit API.
 *
 * @param mockedRequestParams the incoming fetch request
 * @returns results of mocking or undefined if no mock is found
 */
export const getMockedResponse = ({
  url,
  method,
  body,
  pathParams,
  queryParams,
}: MockedResponseParams): object | undefined => {
  const methodHooks = mockHooks[method.toLowerCase()];

  if (!methodHooks) throw new Error(`Unknown method ${method}`);

  const hook = methodHooks.find((h) => h.checkFn(url));
  return hook && hook.mockFn({ pathParams, queryParams, body });
};
